import LayoutFrame from './Frame'
import LayoutBlank from './Blank'
export default function(Vue) {
  Vue.prototype.$addLayout({ layoutDefault: LayoutFrame, LayoutBlank })
}
